import { render, staticRenderFns } from "./CourseListView.vue?vue&type=template&id=5ad5257b&scoped=true&"
import script from "./CourseListView.vue?vue&type=script&lang=ts&"
export * from "./CourseListView.vue?vue&type=script&lang=ts&"
import style0 from "./CourseListView.vue?vue&type=style&index=0&id=5ad5257b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5257b",
  null
  
)

export default component.exports